import React, { useEffect } from "react";
import "./style.scss";
import CloseBtn from "../CloseBtn";
import TitleExpand from "../Expandtitle";
import Location from "../Location";
import Address from "../Address";
import UserCard from "../UserCard";
import Storelist from "../../Store/Actions";
import Api from "../../Utils/Api";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FcDataProtection } from "react-icons/fc";
import moment from "moment";

const Servicedetail = () => {
  const Navigate = useNavigate();

  const {
    CreateRequestDetailsStore,
    setCreateRequestData_,
    RequestUserStore,
    clearCreateRequestData_,
    setAddresslist_,
    setBikelist_,
    setCreatemodal_,
    setServicePackage_,
    setslotTime_,
  } = Storelist();

  const {
    _Post_MobileNumber,
    CreateRquest,
    servicePackageDetail,
    GetServicePackageData,
    GetBrandList,
    GetgearSystemList,
    GetBranchList
  } = Api();


  // const [is_filled, setis_filled] = useState(false);


  const TextInputHandler = (e) => {
    if (e.target.name === "bikeName") {
      e.target.value = e.target.value
        ?.replace(/[^a-z A-Z]+/g, "")
        ?.slice(0, 80);
    }
    setCreateRequestData_({ key: "bike_id", value: "" });
    setCreateRequestData_({ key: e.target.name, value: e.target.value });
  };


  const SelectHandler = (e) => {
    console.log("second slect ")
    console.log(e.target.name, e.target.value);
    setCreateRequestData_({ key: e.target.name, value: e.target.value });
    setCreateRequestData_({ key: "bike_id", value: "" });
    if (e.target.name === "bikeType") {
      setCreateRequestData_({ key: "bikeBrand", value: "" });
      if (RequestUserStore?.gearSystem && RequestUserStore?.city) {
        GetBranchList(true, RequestUserStore?.city, e.target.value)
      }
    }
  };


  const AddBikeItem = (item) => {
    if (!item) return;

    // When changing bicycle, clear serviceRequired and dependent fields
    if (
      RequestUserStore?.bike_id &&
      String(RequestUserStore?.bike_id) !== String(item?._id)
    ) {
      setCreateRequestData_({ key: "serviceRequired", value: "" });
      setCreateRequestData_({ key: "servicePackage", value: "" });
      setCreateRequestData_({ key: "amount", value: "" });
      setCreateRequestData_({ key: "slotDate", value: "" });
      setCreateRequestData_({ key: "slotTime", value: "" });
      setServicePackage_([]);
      setslotTime_([]);
    }

    setCreateRequestData_({ key: "bike_id", value: item?._id });
    setCreateRequestData_({
      key: "bikeType",
      value: item?.bikeType?._id || item?.bikeType || "",
    });
    setCreateRequestData_({
      key: "gearSystem",
      value: item?.gearSystem?._id || item?.gearSystem || "",
    });
    setCreateRequestData_({ key: "bikeName", value: item?.bikeName || "" });
    setCreateRequestData_({
      key: "bikeBrand",
      value: item?.brand?._id || item?.brand || "",
    });
    setCreateRequestData_({
      key: "bikeModel",
      value: item?.model || item?.modelName || "",
    });
    setCreateRequestData_({ key: "amcAvailable", value: item?.amcAvailablity });
    setCreateRequestData_({
      key: "frame_number",
      value: item?.frameNumber || item?.frame_number || "",
    });

    if (item?.amcId) {
      setCreateRequestData_({ key: "amcId", value: item?.amcId });
    } else {
      setCreateRequestData_({ key: "amcId", value: "" });
    }
  };

  const hasAutoSelectedRef = React.useRef(false);

  const warrantyData = RequestUserStore?.warrantyData;
  const warrantyBike = warrantyData?.bikeid || warrantyData?.bicycle;
  const warrantyBikeId = warrantyBike?._id || warrantyBike?.id;

  const showWarranty =
    warrantyData && Object.keys(warrantyData).length > 0;

  const isWarrantyBike = (item) => {
    if (!showWarranty || !warrantyBikeId || !item) return false;
    return String(item?._id) === String(warrantyBikeId);
  };

  const isBikeWarrantyActive = (item) => {
    if (!item) return false;
    const avail = item?.warrantyAvailablity || item?.isWar;
    if (!avail) return false;
    const det = item?.warrantyDetails || {};
    const status = (det?.status || "").toUpperCase();
    if (status && status !== "ACTIVE") return false;
    const expiry = det?.warrantyExpiryDate;
    if (
      expiry &&
      moment(expiry).isValid() &&
      moment(expiry).isBefore(moment(), "day")
    ) {
      return false;
    }
    return true;
  };

  const isWarrantyBikeSelected = isWarrantyBike({ _id: RequestUserStore?.bike_id });

  const warrantyStatus = () => {
    const s = (warrantyData?.status || "").toUpperCase();
    if (s && s !== "ACTIVE") return s;
    const expiry = warrantyData?.warrantyExpiryDate || warrantyData?.endDate;
    if (expiry && moment(expiry).isValid() && moment(expiry).isBefore(moment(), "day")) {
      return "EXPIRED";
    }
    if (!s) return "ACTIVE";
    return "ACTIVE";
  };

  const warrantyTotal = parseInt(
    warrantyData?.totalService ?? warrantyData?.freeServices?.total ?? 2
  );
  const warrantyTaken =
    warrantyData?.serviceCount ??
    warrantyData?.freeServices?.taken ??
    warrantyData?.serviceClaimedDate?.length ??
    0;
  const warrantyRemaining = Math.max(
    0,
    warrantyTotal - parseInt(warrantyTaken)
  );

  const formatWarrantyDate = (dateStr) => {
    if (!dateStr) return "-";
    const m = moment(dateStr);
    return m.isValid() ? m.format("DD/MM/YYYY") : dateStr;
  };

  // Reset auto-select ref when modal closes or warrantyData resets
  useEffect(() => {
    if (!showWarranty) {
      hasAutoSelectedRef.current = false;
    }
  }, [showWarranty]);

  // Auto-select the warranty bicycle once on initial load, allowing user to switch to other bikes
  useEffect(() => {
    if (showWarranty && !hasAutoSelectedRef.current) {
      const bikes = CreateRequestDetailsStore?.bikelist || [];

      let target = null;
      if (warrantyBikeId && bikes.length > 0) {
        target = bikes.find((b) => String(b?._id) === String(warrantyBikeId));
      }
      if (!target && bikes.length > 0) {
        target = bikes[0];
      }
      if (!target && warrantyBike && (warrantyBike?._id || warrantyBike?.brand)) {
        target = warrantyBike;
      }

      if (target) {
        AddBikeItem(target);
        hasAutoSelectedRef.current = true;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showWarranty, CreateRequestDetailsStore?.bikelist, warrantyData]);

  useEffect(() => {
    if (RequestUserStore.bikeType && RequestUserStore.gearSystem) {
      if (RequestUserStore.bike_id) {
        GetServicePackageData(RequestUserStore.bike_id);
        setCreateRequestData_({ key: "servicePackage", value: "" });
      } else {
        GetServicePackageData(null);
      }
    }
    if (RequestUserStore?.bikeType) {
      GetgearSystemList()
    }

    if (RequestUserStore?.gearSystem) {
      // GetServicePackageData(RequestUserStore?.bike_id)
      GetBrandList(true, RequestUserStore?.bikeType)
    }
  }, [
    RequestUserStore.bikeType,
    RequestUserStore.gearSystem,
    RequestUserStore.bike_id,

  ]);

  const SumbitCreateApi = () => {
    //console.logRequestUserStore);
    CreateRquest({
      user_id: RequestUserStore?.user_id,
      servicePackage: RequestUserStore?.servicePackage,
      bike_id: RequestUserStore?.bike_id ? RequestUserStore?.bike_id : null,
      bikeType: RequestUserStore?.bike_id ? "" : RequestUserStore?.bikeType,
      bikeName: RequestUserStore?.bike_id ? "" : RequestUserStore?.bikeName,
      bikeBrand: RequestUserStore?.bike_id ? "" : RequestUserStore?.bikeBrand,
      bikeModel: RequestUserStore?.bike_id ? "" : RequestUserStore?.bikeModel,
      price: RequestUserStore?.price ? "" : RequestUserStore?.amount,
      mobile: RequestUserStore?.mobile,
      name: RequestUserStore?.name,
      address_id: RequestUserStore?.address_id
        ? RequestUserStore?.address_id
        : null,
      address_type: RequestUserStore?.address_id
        ? ""
        : RequestUserStore?.address_type,
      cityId: RequestUserStore?.city ? RequestUserStore?.city : "",
      addressName: RequestUserStore?.address_id
        ? ""
        : RequestUserStore?.addressName,
      stateCode: RequestUserStore?.state?.split("==")[0],
      pincode: RequestUserStore?.address_id ? "" : RequestUserStore?.pincode,
      full_address: RequestUserStore?.address_id
        ? ""
        : RequestUserStore?.full_address,
      frame_number: RequestUserStore?.frame_number,
      branchId: RequestUserStore?.branch,
      serviceRequired: RequestUserStore?.serviceRequired,
      serviceType: RequestUserStore?.serviceRequired,
      slotBooked: RequestUserStore?.slotTime,
      amount: RequestUserStore?.amount,
      packageType: RequestUserStore?.packageType,
      gearType: RequestUserStore.gearSystem,
      amcId: RequestUserStore.amcId ? RequestUserStore.amcId : null,
      emailId: RequestUserStore?.email,
      warrantyId: isWarrantyBikeSelected
        ? RequestUserStore?.warrantyData?.id ||
          RequestUserStore?.warrantyData?._id ||
          RequestUserStore?.warrantyData?.warrantyId ||
          null
        : null,
    });
  };

  const ValueValidation = (value, msg) => {
    if (!value) {
      toast.warning(msg, {
        position: "top-center",
      });
      toast.clearWaitingQueue();
      return;
    } else {
      return true;
    }
  };


  function isValidEmail(email) {
    const emailRegex =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return emailRegex.test(email);
  }

  const SumbitRequestHandler = () => {
    if (showWarranty && isWarrantyBikeSelected && warrantyStatus() !== "ACTIVE") {
      toast.warning(
        `Warranty is not active. Current status: ${warrantyStatus()}`,
        { position: "top-center" }
      );
      toast.clearWaitingQueue();
      return;
    }
    const checkValues = () => {
      
      if (
        ValueValidation(
          String(RequestUserStore?.branch),
          "Kindly select branch"
        ) &&
        ValueValidation(
          String(RequestUserStore?.serviceRequired),
          "Kindly select service required"
        ) &&
        ValueValidation(
          String(RequestUserStore?.servicePackage),
          "Kindly select service package"
        ) &&
        ValueValidation(String(RequestUserStore?.amount), "Kindly fill amount")
      ) {
        if (
          !String(RequestUserStore?.bike_id) &&
          !(
            ValueValidation(
              String(RequestUserStore?.bikeType),
              "Kindly select bike type"
            ) &&
            ValueValidation(
              String(RequestUserStore?.bikeBrand),
              "Kindly fill bike brand"
            ) &&
            ValueValidation(
              String(RequestUserStore?.bikeModel),
              "Kindly fill bike model"
            )
          )
        ) {
          return;
        }
        if (
          ValueValidation(
            String(RequestUserStore?.slotDate),
            "Kindly select booking Date"
          ) &&
          ValueValidation(
            String(RequestUserStore?.slotTime),
            "Kindly select slot Time"
          )
        ) {
          SumbitCreateApi();
        }
      }
    };

    if (String(RequestUserStore?.mobile)?.length !== 10) {
      toast.warning("Kindly fill mobile number", {
        position: "top-center",
      });
      toast.clearWaitingQueue();
      return;
    }

    if (!isValidEmail(RequestUserStore?.email)) {
      toast.warning("Kindly fill valid email", {
        position: "top-center",
      });
      toast.clearWaitingQueue();
      return;
    }
    
    if (
      ValueValidation(
        String(RequestUserStore?.name),
        "Kindly fill customer name"
      )
    ) {
      if (!RequestUserStore?.address_id) {
        if (
          ValueValidation(
            String(RequestUserStore?.addressName),
            "Kindly fill address name"
          ) &&
          ValueValidation(
            String(RequestUserStore?.address_type),
            "Kindly fill address type"
          ) &&
          ValueValidation(
            String(RequestUserStore?.full_address),
            "Kindly fill full address"
          ) &&
          ValueValidation(
            String(RequestUserStore?.state),
            "Kindly select state"
          ) &&
          ValueValidation(
            String(RequestUserStore?.city),
            "Kindly select city"
          ) &&
          ValueValidation(
            String(RequestUserStore?.pincode),
            "Kindly fill pincode"
          )
        ) {
          checkValues();
        }
      } else {
        checkValues();
      }
    }
  };

  return (
    <div className="service-details-container">
      <CloseBtn
        color={"--light"}
        closeHandler={() => {
          clearCreateRequestData_();
          setCreatemodal_(false);
          setAddresslist_([]);
          setBikelist_([]);
        }}
      />

      <div className="create-offer-wrapper">
        {RequestUserStore?.name && (
          <UserCard
            title={RequestUserStore?.name}
            titleDescription={`Member since ${RequestUserStore?.member_on}`}
            day={""}
            date={""}
            color={"--light"}
          />
        )}

        {showWarranty && (
          <div className="warranty-eligibility-box">
            <div className="warranty-eligible-tag">
              <FcDataProtection size={16} />
              <span>Warranty / Free Service Eligible</span>
            </div>
            <div className="warranty-eligibility-details">
              <div className="list-item">
                <p className="title">Warranty Status</p>
                <p className="value">{warrantyStatus()}</p>
              </div>
              <div className="list-item">
                <p className="title">Validity / Expiry</p>
                <p className="value">
                  {formatWarrantyDate(
                    warrantyData?.warrantyExpiryDate || warrantyData?.endDate
                  )}
                </p>
              </div>
              <div className="list-item">
                <p className="title">Free Services Available</p>
                <p className="value">{warrantyTotal}</p>
              </div>
              <div className="list-item">
                <p className="title">Free Services Completed</p>
                <p className="value">{warrantyTaken}</p>
              </div>
              <div className="list-item">
                <p className="title">Remaining Free Services</p>
                <p className="value">{warrantyRemaining}</p>
              </div>
            </div>
          </div>
        )}

        {String(RequestUserStore?.mobile)?.length < 10 && (
          <TitleExpand title={"service offers"} color={"--light"} />
        )}
        {String(RequestUserStore?.mobile)?.length < 10 && (
          <Location tag={"AMC"}>
            <span>50% OFFER</span>
          </Location>
        )}
        {String(RequestUserStore?.mobile)?.length < 10 && (
          <Location tag={"SPORTS"}>
            <span>30% OFFER</span>
          </Location>
        )}
        {String(RequestUserStore?.mobile)?.length < 10 && (
          <TitleExpand title={"product offer"} color={"--light"} />
        )}

        {String(RequestUserStore?.mobile)?.length < 10 && (
          <div className="create-request-offer-img-container">
            <img src="https://placehold.co/300x300" alt="" />
          </div>
        )}

        {String(RequestUserStore?.mobile)?.length >= 10 && (
          <div className="bike-add-container">
            <div className="input-item-wrapper">
              <label htmlFor="name">
                <TitleExpand title={"Add bicycle"} color={"--light"} />
              </label>
              {/* BIKE TYPE */}
              <div className="input-item-field">
                <select
                  name="bikeType"
                  id="bikeType"
                  value={RequestUserStore?.bikeType}
                  onChange={SelectHandler}
                >
                  <option value="" disabled selected>
                    Bicycle type
                  </option>
                  {CreateRequestDetailsStore?.bikeType?.map((item, index) => {
                    return (
                      <option key={item?._id} value={item?._id}>
                        {item?.configValue}
                      </option>
                    );
                  })}
                </select>
              </div>
              {/* GEAR SYSTEM */}
              <div className="input-item-field">
                <select
                  name="gearSystem"
                  id="bikeType"
                  value={RequestUserStore?.gearSystem}
                  onChange={SelectHandler}
                >
                  <option value="" disabled selected>
                    Gear Type
                  </option>
                  {CreateRequestDetailsStore?.gearSystem?.map((item, index) => {
                    return (
                      <option key={item?._id} value={item?._id}>
                        {item?.configValue}
                      </option>
                    );
                  })}
                </select>
              </div>
              {/* BIKE BRAND */}
              <div className="input-item-field">
                <select
                  name="bikeBrand"
                  id="bikeType"
                  value={RequestUserStore?.bikeBrand}
                  onChange={SelectHandler}
                >
                  <option value="" disabled selected>
                    Bicycle Brand
                  </option>
                  {CreateRequestDetailsStore?.brandList?.map((item, index) => {
                    return (
                      <option key={item?._id} value={item?._id}>
                        {item?.brandName}
                      </option>
                    );
                  })}
                </select>
              </div>
              {/* BIKE MODEL */}
              <div className="input-item-field">
                <input
                  type="text"
                  placeholder="Bicycle model"
                  name="bikeModel"
                  id="bikeModel"
                  onInput={TextInputHandler}
                  value={RequestUserStore?.bikeModel}
                />
              </div>
              {/* Frame Number */}
              <div className="input-item-field">
                <input
                  type="text"
                  placeholder="Frame number"
                  name="frame_number"
                  id="frame_number"
                  onInput={TextInputHandler}
                  value={RequestUserStore?.frame_number}
                />
              </div>
            </div>

            {CreateRequestDetailsStore?.bikelist?.length > 0 && (
              <div className="choose-bike-container">
                <p className="title">Choose bicycle</p>

                <div className="choose-bike-list-container">
                  {CreateRequestDetailsStore?.bikelist?.map((item, index) => {
                    return (
                      <button
                        key={item?._id}
                        className={`choose-bike-item ${
                          String(RequestUserStore?.bike_id) === String(item?._id) ? "active" : ""
                        } relative`}
                        onClick={() => {
                          AddBikeItem(item);
                        }}
                      >
                        {item?.amcAvailablity ? (
                          <div className="absolute top-[-10px] right-[-2px]">
                            <img
                              src="/images/amc_logo.png"
                              alt="amc"
                              width={25}
                            />
                          </div>
                        ) : null}
                        {isBikeWarrantyActive(item) ? (
                          <div
                            className={`absolute top-[-10px] ${
                              item?.amcAvailablity
                                ? "right-[22px]"
                                : "right-[-2px]"
                            }`}
                            title="Warranty"
                          >
                            <img
                              src="/images/warranty_logo.png"
                              alt="warranty"
                              width={25}
                            />
                          </div>
                        ) : null}

                        <p>
                          {`${item?.brand?.brandName} ${item?.model}` ||
                            `Bicycle ${index + 1}`}
                        </p>
                        <p className="date">
                          {item?.created
                            ? item?.created
                                ?.split("T")[0]
                                ?.split("-")
                                ?.reverse()
                                ?.join("-")
                            : ""}
                        </p>
                      </button>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        )}

        <div className="create-request-btn-container">
          <button className="create" onClick={SumbitRequestHandler}>
            Create request
          </button>
          <button
            className="cancel"
            onClick={() => {
              clearCreateRequestData_();
              setCreatemodal_(false);
              setAddresslist_([]);
              setBikelist_([]);
            }}
          >
            cancel
          </button>
        </div>
      </div>

      <div className="change-reason-container">
        <TitleExpand title={"Reason for change"} color={"--light"} />
        <p className="reason-text">
          Lorem, ipsum dolor sit amet consectetur adipisicing elit. Possimus
          magnam delectus repellat blanditiis suscipit dolorem consequuntur
          minus aliqui
        </p>
        <p className="thank">Thank you</p>
      </div>
    </div>
  );
};

export default Servicedetail;
